/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { useCallback, useState, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { updateCrmObject } from './api/crmObjectsAPI';
import PropertyInputV2 from 'customer-data-properties/input/PropertyInputV2';
import { alwaysUndefined } from '../../utils/alwaysUndefined';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Form } from 'foundations-components/transitional/components/Form';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Text } from 'foundations-components/components/Text';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ClickToAssignModal = ({
  objectTypeId,
  objectId,
  propertyDefinition,
  currentValue,
  onClose,
  onSuccess,
  onFailure
}) => {
  const [selectedOwner, setSelectedOwner] = useState(currentValue);
  const handleChange = useCallback(changes => setSelectedOwner(changes[propertyDefinition.name]), [propertyDefinition.name]);
  const handleSubmit = useCallback(event => {
    event.preventDefault();
    const propertyValues = [{
      name: propertyDefinition.name,
      value: selectedOwner
    }];
    return updateCrmObject({
      objectTypeId,
      objectId,
      propertyValues
    }).then(() => {
      onSuccess(propertyValues);
      onClose();
    }).catch(() => {
      onFailure(propertyValues);
      onClose();
    });
  }, [objectId, objectTypeId, onClose, onFailure, onSuccess, propertyDefinition.name, selectedOwner]);
  const formControlProps = useMemo(() => ({
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "datatable.clickToAssign.label"
    })
  }), []);
  return /*#__PURE__*/_jsx(Modal, {
    children: /*#__PURE__*/_jsxs(Form, {
      onSubmit: handleSubmit,
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "datatable.clickToAssign.title"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        })]
      }), /*#__PURE__*/_jsx(DialogBody, {
        children: /*#__PURE__*/_jsx(PropertyInputV2, {
          formControlProps: formControlProps,
          objectTypeId: objectTypeId,
          objectId: objectId,
          property: propertyDefinition,
          value: selectedOwner,
          onChange: handleChange,
          getDraftValue: alwaysUndefined,
          getSavedValue: alwaysUndefined
          // Temporarily disable validation in UIs that don't require it.
          // To re-enable, wire up `onValidationChange` to disable saving.
          ,
          disableValidation: true
        })
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          "data-test-id": "confirm-click-to-assign",
          use: "primary",
          type: "submit",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "datatable.clickToAssign.assign"
          })
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "cancel-click-to-assign",
          use: "secondary",
          onClick: onClose,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "datatable.clickToAssign.cancel"
          })
        })]
      })]
    })
  });
};
export default ClickToAssignModal;